import {
  getBrandRoute,
  getProductRoute,
  HeartButton,
  ProductPrice,
} from "@ten24/slatwall-storefront-react-private/global";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { CardProductQuantityInput } from "../ProductCard";
import { DropdownButtons } from "../ListingButtons";
import ProductCardImage from "../ProductCardImage";
import { ProductOutOfStock } from "../../ProductOutOfStock/ProductOutOfStock";

const ProductCardWithDetail = ({
  product,
  cardConfiguration = {
    showPrice: true,
    showSkuCode: true,
    showProductCode: false,
    showBrand: false,
    enableFavorites: false,
    buttons: [],
    input: {
      showCriteria: "none",
      label: "",
    },
  },
}) => {
  const [isFetching, setFetching] = useState(false);
  const [itemCount, setItemCount] = useState(1);

  const skuCode = product.product_defaultSku_skuCode ?? product.skuCode ?? "";
  const skuUom = product?.optionGroups?.length > 0 ? product.optionGroups[0].optionGroupName : "";

  const { skuID, urlTitle, salePrice, listPrice, settings, brandName, brandUrlTitle, productCode } = product;

  const productRoute = useSelector(getProductRoute);
  const brandRoute = useSelector(getBrandRoute);
  const productLink = `/${productRoute}/${urlTitle}` + (skuID.length ? `?skuid=${skuID}` : "");

  return (
    <div className="card productCardWithDetail p-3 my-2">
      <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start">
        <div className="d-flex flex-column align-items-center flex-shrink-0">
          <Link to={productLink} style={{ maxHeight: 160, maxWidth: 160, overflow: 'hidden' }}>
            <ProductCardImage product={product} />
          </Link>
          {cardConfiguration.enableFavorites && (
            <HeartButton skuID={skuID} className=" align-self-center link btn-wishlist" />
          )}
        </div>

        <div className="flex-grow-1">
          <div className="d-flex justify-content-between flex-wrap">
            <div className="col-12 col-md-8 pb-2">
              <Link to={productLink} className="product-name">
                <h5 className="mx-1">{product.product_productName}</h5>
              </Link>
              {cardConfiguration?.showBrand && (
                <Link to={`/${brandRoute}/${brandUrlTitle}`} className="text-capitalize product-brand mx-1">
                  {brandName}
                </Link>
              )}
              <div
                dangerouslySetInnerHTML={{
                  __html: product.product_productDescription,
                }}
              />
            </div>
            <div className="d-flex col-12 col-md-4 flex-column align-items-center">
              {cardConfiguration.showProductCode && productCode && <div>Product Code: {productCode}</div>}
              {cardConfiguration.showSkuCode && (
                <>
                  <div>SKU : {skuCode}</div>
                  {skuUom !== "" && <div>UOM : {skuUom}</div>}
                </>
              )}
              {cardConfiguration.showPrice && (
                <h4 className="text-primary d-flex pt-2">
                  <span>Price: </span>
                  <span>
                    <ProductPrice
                      salePrice={salePrice}
                      listPrice={listPrice}
                      ShowPriceForUserType={settings?.skuShowPriceForUserType}
                    />
                  </span>
                </h4>
              )}
              <ProductOutOfStock cssClass={"mb-4"} isFetching={isFetching} sku={product} />
              <CardProductQuantityInput
                skuSettings={settings}
                cardConfiguration={cardConfiguration}
                isProductInStock={true}
                setQuantity={setItemCount}
                quantity={itemCount}
                sku={product}
                stock={product.calculatedQATS || product.stocks_calculatedQATS}
              />
              <DropdownButtons
                skuSettings={settings}
                cardConfiguration={cardConfiguration}
                isProductInStock={true}
                productLink={productLink}
                isFetching={isFetching}
                skuID={skuID}
                itemCount={itemCount}
                setFetching={setFetching}
                setItemCount={setItemCount}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ProductCardWithDetail };
